import React, { Component } from "react";
import { connect } from "react-redux";

import { TextField, Select } from "./FormElements";
import Switch from "@material-ui/core/Switch";
import ImageUploader from "./ImageUploader";

import { validURL, l, getLangLabel, pagesOptions } from "../functions";
import ListSortedItemsCheckboxes from "./ListSortedItemsCheckboxes";
import ProductFilter from "./ProductFilter";
import Icon from "./Icons";

const mapStateToProps = (state) => {
  return {
    fetchedPages: state.rootReducer.fetchedPages || [],
    fetchedCategories: state.rootReducer.fetchedCategories || {},
    fetchedLangs: state.rootReducer.fetchedLangs || [],
    currentLang: state.rootReducer.currentLang || 1,
  };
};
class MenuDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      slide: null,
    };
  }

  componentDidMount() {
    this.setState({ slide: this.props.slide });
  }

  _changedField = (key, value) => {
    this.setState({
      ...this.state,
      slide: {
        ...this.state.slide,
        content:
          key === "title_1"
            ? value.substring(0, 16) + (value.length > 16 ? "..." : "")
            : this.state.slide.content,
        data: {
          ...this.state.slide.data,
          [key]: value,
        },
      },
    });
  };

  _changedBgImage = (url) => {
    this.setState({
      ...this.state,
      slide: {
        ...this.state.slide,
        data: {
          ...this.state.slide.data,
          ["image_" + this.props.currentLang]: url,
        },
      },
    });
  };

  _saveSlide = () => {
    this.props.onSave(this.state.slide);
  };

  _getImage = () => {
    let image = "";

    if (this.state.slide && this.state.slide.data) {
      if (
        this.state.slide.data["image_" + this.props.currentLang] !==
          undefined &&
        this.state.slide.data["image_" + this.props.currentLang] !== null
      )
        image = this.state.slide.data["image_" + this.props.currentLang];
      else if (
        this.state.slide.data["image"] !== undefined &&
        this.state.slide.data["image"] !== null
      )
        image = this.state.slide.data["image"];
    }

    return image;
  };

  render() {
    return (
      <div className="slide-dialog">
        <div className="head">
          <Icon icon="time" onClick={this.props.onClose} />{" "}
          <h3>{l("Edit item")}</h3>
          <button className="new-item" onClick={this._saveSlide}>
            <Icon icon="check" />
          </button>
        </div>
        <div className="form">
          <div className="section">
            <ImageUploader
              withIcon={true}
              buttonText={l("Upload image")}
              onChange={this._changedBgImage}
              imgExtension={[".jpg", ".gif", ".png", ".jpeg", "webp"]}
              maxFileSize={5242880}
              withPreview={true}
              singleImage={true}
              defaultImages={this._getImage()}
            />
          </div>
          <hr />
          <div className="section">
            <TextField
              label={l("Title") + " (" + getLangLabel() + ")"}
              solid
              dark
              value={
                (this.state.slide &&
                  this.state.slide.data &&
                  this.state.slide.data["title_" + this.props.currentLang]) ||
                ""
              }
              onChange={(value) => {
                this._changedField("title_" + this.props.currentLang, value);
              }}
            />
          </div>
          <div className="section">
            <TextField
              label={l("Subtitle") + " (" + getLangLabel() + ")"}
              solid
              dark
              value={
                (this.state.slide &&
                  this.state.slide.data &&
                  this.state.slide.data[
                    "subtitle_" + this.props.currentLang
                  ]) ||
                ""
              }
              onChange={(value) => {
                this._changedField("subtitle_" + this.props.currentLang, value);
              }}
            />
          </div>

          {this.props.isTestimonial && (
            <div className="section">
              <TextField
                solid
                dark
                multiline
                label={l("Testimonial") + " (" + getLangLabel() + ")"}
                value={
                  (this.state.slide &&
                    this.state.slide.data &&
                    this.state.slide.data["text_" + this.props.currentLang]) ||
                  ""
                }
                onChange={(value) => {
                  this._changedField("text_" + this.props.currentLang, value);
                }}
              />
            </div>
          )}

          {!this.props.isTestimonial && <hr />}

          {!this.props.isTestimonial && (
            <div className="section">
              <div className="gk-form-row-container">
                <label className="small">{l("This item has a link")}</label>

                <Switch
                  checked={
                    (this.state.slide &&
                      this.state.slide.data &&
                      this.state.slide.data.hasUrl !== undefined &&
                      this.state.slide.data.hasUrl) ||
                    false
                  }
                  onChange={(e) => {
                    this._changedField("hasUrl", e.target.checked);
                  }}
                />
              </div>
            </div>
          )}

          {this.state.slide &&
            this.state.slide.data &&
            this.state.slide.data.hasUrl && (
              <div className="section">
                <TextField
                  solid
                  dark
                  label={l("Link label") + " (" + getLangLabel() + ")"}
                  value={
                    (this.state.slide &&
                      this.state.slide.data &&
                      this.state.slide.data[
                        "linklabel_" + this.props.currentLang
                      ]) ||
                    ""
                  }
                  onChange={(value) => {
                    this._changedField(
                      "linklabel_" + this.props.currentLang,
                      value
                    );
                  }}
                />
              </div>
            )}

          {this.state.slide &&
            this.state.slide.data &&
            this.state.slide.data.hasUrl && (
              <div className="section">
                <ul className="inline-options dark grow">
                  <li
                    onClick={() => {
                      this._changedField("target", "_self");
                    }}
                    className={
                      this.state.slide &&
                      this.state.slide.data &&
                      this.state.slide.data.target !== "_blank"
                        ? "selected"
                        : ""
                    }
                  >
                    <span>{l("Same window")}</span>
                  </li>
                  <li
                    onClick={() => {
                      this._changedField("target", "_blank");
                    }}
                    className={
                      this.state.slide &&
                      this.state.slide.data &&
                      this.state.slide.data.target === "_blank"
                        ? "selected"
                        : ""
                    }
                  >
                    <span>{l("New window")}</span>
                  </li>
                </ul>
              </div>
            )}

          {this.state.slide &&
            this.state.slide.data &&
            this.state.slide.data.hasUrl && (
              <div className="section">
                <div className="gk-form-row-container">
                  <label className="small">{l("Link type")}</label>
                  <Select
                    placeholder={l("Link type")}
                    value={
                      (this.state.slide &&
                        this.state.slide.data &&
                        this.state.slide.data.linkType) ||
                      ""
                    }
                    onChange={(value) => {
                      this._changedField("linkType", value);
                    }}
                    options={[
                      {
                        label: l("Custom"),
                        value: "custom",
                      },
                      {
                        label: l("Product"),
                        value: "product",
                      },
                      {
                        label: l("Category"),
                        value: "category",
                      },
                      {
                        label: l("Page"),
                        value: "cms",
                      },
                    ]}
                    dark
                  />
                </div>
              </div>
            )}

          {this.state.slide &&
            this.state.slide.data &&
            this.state.slide.data.hasUrl &&
            this.state.slide.data.linkType &&
            this.state.slide.data.linkType === "product" && (
              <div className="section">
                <ProductFilter
                  label={l("Filter product")}
                  list={
                    this.state.slide &&
                    this.state.slide.data &&
                    this.state.slide.data.url &&
                    this.state.slide.data.url.includes("product__")
                      ? this.state.slide.data.url.replace("product__", "")
                      : ""
                  }
                  onCheck={(product) => {
                    this._changedField("url", "product__" + product);
                  }}
                />
              </div>
            )}

          {this.state.slide &&
            this.state.slide.data &&
            this.state.slide.data.hasUrl &&
            this.state.slide.data.linkType &&
            this.state.slide.data.linkType === "category" && (
              <div className="section">
                <label className="small">{l("Select a category")}</label>
                <ListSortedItemsCheckboxes
                  list={
                    this.state.slide &&
                    this.state.slide.data &&
                    this.state.slide.data.url &&
                    this.state.slide.data.url.includes("category__")
                      ? this.state.slide.data.url.replace("category__", "")
                      : ""
                  }
                  onCheck={(list) => {
                    this._changedField("url", "category__" + list);
                  }}
                  items={this.props.fetchedCategories.leveled}
                  inlineItems={this.props.fetchedCategories.normal}
                />
              </div>
            )}

          {this.state.slide &&
            this.state.slide.data &&
            this.state.slide.data.hasUrl &&
            this.state.slide.data.linkType &&
            this.state.slide.data.linkType === "cms" && (
              <div className="section">
                <div className="gk-form-row-container">
                  <label className="small">{l("Page")}</label>
                  <Select
                    placeholder={l("Select page")}
                    value={
                      (this.state.slide &&
                        this.state.slide.data &&
                        this.state.slide.data.url &&
                        this.state.slide.data.url.includes("cms__") &&
                        this.state.slide.data.url) ||
                      ""
                    }
                    onChange={(value) => {
                      this._changedField("url", value);
                    }}
                    options={pagesOptions("cms")}
                    dark
                  />
                </div>
              </div>
            )}

          {this.state.slide &&
            this.state.slide.data &&
            this.state.slide.data.hasUrl &&
            this.state.slide.data.linkType &&
            this.state.slide.data.linkType === "custom" && (
              <div className="section">
                <TextField
                  placeholder={l("Custom url")}
                  info={l("Secured link is recommanded")}
                  value={
                    this.state.slide &&
                    this.state.slide.data &&
                    this.state.slide.data.url &&
                    this.state.slide.data.url.includes("custom__")
                      ? this.state.slide.data.url.replace("custom__", "")
                      : ""
                  }
                  onChange={(value) => {
                    this._changedField("url", "custom__" + value);
                  }}
                  dark
                  error={
                    !validURL(
                      this.state.slide &&
                        this.state.slide.data &&
                        this.state.slide.data.url &&
                        this.state.slide.data.url.includes("custom__")
                        ? this.state.slide.data.url.replace("custom__", "")
                        : ""
                    )
                      ? l("Url format not correct")
                      : false
                  }
                />
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(MenuDialog);
